import React, {Component} from 'react';
import { connect } from 'react-redux';
import {getVerifyCode, verifyRegisterPhone,realUserMobileCaptcha} from '../../action/investmentAction.js';
import {userBindingMobile} from '../../action/loginAction.js';
import NavigatorMain from '../NavigatorMain';
import Util from '../../util.js';
import { Toast } from 'antd-mobile/lib';
import { hashHistory } from 'react-router';
import { goHome,getStorage } from '../../common.js';

let intervalId = null;
let requestId = '';

class HxjjBindingMobile extends Component{
  constructor(props) {
    super(props);
    this.state = {
      verifyCode: '',
      phoneNum: '',
      isRequestingVerifyCode: false,
      countDown: 120,
      flag: false,
      enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
    }
    this.goCallback=false;
  }
  handleVerify = () => {
    if(!this.state.verifyCode || !this.state.phoneNum){
      Toast.info('请输入信息', 2);
      return;
    }
    if(!(/^1[0123456789]\d{9}$/.test(this.state.phoneNum))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    if(requestId === '' || !requestId){
      Toast.info('请先申请手机验证码', 2);
      return ;
    }
    let verifyParam = {
      requestId : requestId,
      mobileNo : this.state.phoneNum,
      mobileCaptchaText : this.state.verifyCode,
      token: this.props.location.state.content.shortToken
    }
    this.setState({
      flag: true
    })
    this.props.dispatch(userBindingMobile(verifyParam, this.props.location.state.content, ()=>{this.verifySuccess()}, (msg)=>this.verifyError(msg)));
  }

  verifySuccess = async () => {
    this.goCallback=true;
    if (window.navigator.userAgent.indexOf("amcfmapp")>-1) {
      hashHistory.go(-2);
    }else{
      if(this.state.enterType){
        // goHome("Investment");
        if(this.state.enterType=='SubscriptionDetail'){
          hashHistory.go(-2);
          
        }else if(this.state.enterType=='Answer'){
          console.log("进入答题")
          hashHistory.push({
            pathname:'/AnswerActivityDatillPage',
            state:{},
            query: {enterType:"Answer", activityId:this.props.location.query.activityId}
          })
        }else if(this.state.enterType == "activity"){
            let currentUserInfo= await getStorage('currentUserInfo');
            let userId_a = currentUserInfo.userId ? currentUserInfo.userId : "";
            let tradeAccountNo_a = currentUserInfo.tradeAccountNo ? currentUserInfo.tradeAccountNo : "";
            let paramsStr = "userId=" +  userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
            console.log(paramsStr)
            let paramsData = window.encodeURIComponent(Util.aesEncrypt(paramsStr));
            window.location.href = Util.hdUrl + paramsData
        }else{
          hashHistory.replace({
             pathname:'/?enterType="Investment' ,
          })
        }
      }else{
        hashHistory.go(-3);
      }
    }
  }
  verifyError = (msg) => {
    this.setState({
      flag: false
    })
    Toast.info(msg, 2);
  }

  verifyRegisterPhoneSuc = (phoneNum) => {
    let params = { mobileNo: phoneNum }
    this.props.dispatch(realUserMobileCaptcha(params, (requestid)=>{requestId = requestid; }));
  }

  verifyRegisterPhoneErr = (msg) => {
    Toast.info(msg, 2);
    if(intervalId)
      clearInterval(intervalId);
    intervalId = null;
    this.setState({
      isRequestingVerifyCode: false
    });
  }

  handleWaitingForVC = () => {
    if(!(/^1[0123456789]\d{9}$/.test(this.state.phoneNum))){
      Toast.info('请输入正确的手机号码', 2);
      return ;
    }
    this.props.dispatch(verifyRegisterPhone({mobileNo: this.state.phoneNum}, (phoneNum)=>{this.verifyRegisterPhoneSuc(phoneNum)}, (msg)=>{this.verifyRegisterPhoneErr(msg)}));
    let countNum = 119;
    this.setState({isRequestingVerifyCode: true, countDown: countNum}, ()=>{
      intervalId = setInterval(() => {
        countNum--;
        if(countNum < 0){
          cancelTimeOut();
          this.setState({
            isRequestingVerifyCode: false
          });
        }
        this.setState({
          countDown: countNum
        })
      }, 1000);
      const cancelTimeOut = () => {
        if(intervalId)
          clearInterval(intervalId);
        intervalId = null;
      }
    });
  }

  componentWillUnmount(){
    requestId = '';
    this.setState({
      flag: false
    })
    if(intervalId) {
      clearInterval(intervalId);
    };
    if (this.goCallback) {
      this.props.location.state.callback ? this.props.location.state.callback() : null
    }
  }

  goBack = () => {
    hashHistory.goBack();
  }

  changePhoneNo = (event) => {
    this.setState({
      phoneNum: event.target.value
    });
  }

  changeVerifyCode = (event) => {
    this.setState({
      verifyCode: event.target.value
    });
  }

  clearPhoneNum = () => {
    this.setState({
      phoneNum: ""
    });
  }

  componentWillMount() {
    document.title = "绑定手机号";
  }

  render(){
    return (
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>绑定手机号</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style = {{
            width: window.winWidth,
            height: "auto"
          }}>
            <span style = {{
              color: '#5b6370',
              marginTop: 25,
              marginBottom: 12,
              fontSize: 13,
              marginLeft: 13,
              marginRight: 13,
              display: 'block',
              lineHeight: "18px"
            }}>
              尊敬的客户，你还没有绑定手机号！为了确保您的账户安全，请绑定您的手机号：
            </span>
          </div>
          <div style = {{
            width: window.winWidth,
            height: "auto"
          }}>
            <div style = {{
              width:'auto',
              height: 45,
              borderBottom: "1px solid  rgba(242,245,247,1)",
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              display: "-webkit-flex",
              position: "relative"
            }}>
              <span style = {{
                color: '#3a3e47',
                paddingLeft: 13,
                fontSize: 13,
                width: 90
              }}>手机号</span>
              <div style = {{
                display: "-webkit-flex",
                WebkitFlexDirection: 'row',
                WebkitAlignItems: 'center',
                WebkitFlex: 1
              }}>
                <input autocomplete="off" type = "text" style = {{color: "#3a3e47", fontSize: 13, WebkitFlex: 1}} placeholder = '请输入手机号' value = {this.state.phoneNum} onChange = {this.changePhoneNo} />
                <div>
                  <img onClick={this.clearPhoneNum} src={require('../../img/login_input_cancel.png')} style={{marginRight: -2, width: 44, height: 44}}  />
                </div>
              </div>
            </div>
          </div>
          <div style = {{
            width:'auto',
            height: 45,
            borderBottom: "1px solid  rgba(242,245,247,1)",
            backgroundColor: '#ffffff',
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            display: "-webkit-flex"
          }}>
            <span style = {{
              color: '#3a3e47',
              paddingLeft: 13,
              fontSize: 13,
              width: 90
            }}>手机动态码</span>
            <div style = {{
              display: "-webkit-flex",
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              WebkitFlex: 1
            }}>
              <div style={{WebkitFlex: 1, paddingRight: 10}}><input autocomplete="off" type = "text" style = {{color: "#3a3e47", fontSize: 13, width: "100%"}} placeholder = '请输入短信验证码' value = {this.state.verifyCode} onChange = {this.changeVerifyCode} /></div>
              {
                this.state.isRequestingVerifyCode ? 
                <div style = {{
                  backgroundColor: '#d8dbdd',
                  height: 27,
                  borderRadius: 13,
                  paddingLeft: 10,
                  paddingRight:10,
                  WebkitAlignItems: 'center',
                  WebkitJustifyContent: 'center',
                  display: "-webkit-flex",
                  marginRight: 10,
                  width: 110
                }}>
                  <span style = {{color: "#5b6370", fontSize: 13}}>{this.state.countDown}秒后重发</span>
                </div>
                :
                <div style={{"white-space": "nowrap", width: 110, textAlign: "right", paddingRight: 13}}>
                  <span  onClick = {this.handleWaitingForVC} style = {{
                    color: '#fa063a',
                    fontSize: 13
                  }} >获取验证码</span>
                </div>
              }         
            </div>
          </div>
          <div  style = {{
            marginTop: 15,
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20
          }}  onClick = {this.state.verifyCode && this.state.phoneNum ? this.handleVerify : null }>
            <div style = {{backgroundColor: this.state.verifyCode && this.state.phoneNum ? '#fa063a' : '#afb0b2' ,WebkitAlignItems: 'center',WebkitJustifyContent: 'center',height: 40,borderRadius: 20,WebkitFlexDirection: 'row',display: "-webkit-flex"}}>
              <span style = {{color: '#ffffff', fontSize: 15}}>绑定</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}
export default connect(mapStateToProps)(HxjjBindingMobile);


// WEBPACK FOOTER //
// ./src/components/login/HxjjBindingMobile.js